
(function() {
  'use strict';

  /* Section technique interrogee pour les variants au-dela de 250.
     Doit correspondre au nom du fichier sections/couloir-stock.liquid */
  var STOCK_SECTION = 'couloir-stock';
  var PAGE_SIZE     = 50;    /* doit refléter le "by 50" de couloir-stock.liquid */
  var INLINE_CAP    = 250;   /* plafond Liquid de product.variants */
  var FETCH_TIMEOUT = 5000;  /* ms : au-dela, repli sur le metafield */

  /* i18n R2b : table lue UNE fois, repli code (CONVENTION.md § 3). */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Sous Shopify Markets en sous-repertoires, un lien ecrit « /pages/contact »
     sort du marche courant et perd la langue. `Shopify.routes.root` vaut « / »
     en francais et « /en/ » sur un marche anglais : c'est la seule racine
     fiable cote JS. */
  var CONTACT_URL = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
                  + 'pages/contact';
  /* PRIX-COULOIR, 19/10 : meme racine pour `cart/add.js` et `cart.js`. Sans
     elle, le panier relu apres l'ajout revenait en francais et le tiroir
     affichait le titre et l'option en francais sur /cs/ (regle « Panier Ajax
     et langue » du 06/09). */
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var root = document.getElementById('couloir-calculator');
  if (!root) return;

  /* ─── Parse matrice (prix + IDs depuis metafield) ─── */
  var data;
  try { data = JSON.parse(root.dataset.matrix); }
  catch (e) {
    root.innerHTML = '<p style="color:red;font-size:14px;">' + esc(S.couloirDonneesInvalides || '⚠ Matrice variants invalide.') + '</p>';
    return;
  }

  var byWidth = data.matrix || {};

  /* ─── Largeurs réellement existantes (injectées par Liquid, sans plafond) ─── */
  /* i18n R2f : on ne retient que les nombres EXPLOITABLES. Si l'extraction
     Liquid echoue en bloc (c'est ce qui est arrive en `/en`, ou le libelle
     traduit « Width 60 cm » rendait la liste [0,0,0,...]), la liste vide ne
     doit PAS eteindre le calculateur : on renonce alors au filtre plutot que
     d'afficher « produit indisponible » sur un produit qui ne l'est pas. Une
     largeur isolee qui ne s'extrait pas reste, elle, ecartee : le filtre garde
     son role d'origine, supprimer les boutons fantomes. */
  var liveWidths = null;
  try {
    var lw = JSON.parse(root.dataset.liveWidths || 'null');
    if (lw && lw.length) {
      var lwNum = lw.map(Number).filter(function (n) { return isFinite(n) && n > 0; });
      if (lwNum.length) liveWidths = lwNum;
    }
  } catch (e) {}

  /* Candidates = présentes dans la matrice ET toujours existantes sur le produit.
     Ce filtre supprime les boutons fantômes (variant supprimé côté Shopify mais
     encore listé dans le metafield → ID mort → erreur au checkout). */
  var candidateWidths = Object.keys(byWidth).map(Number).sort(function(a, b) { return a - b; });
  if (liveWidths) {
    candidateWidths = candidateWidths.filter(function(w) { return liveWidths.indexOf(w) !== -1; });
  }

  if (!candidateWidths.length) {
    root.innerHTML = '<p style="color:#737373;font-size:14px;">' + esc(S.couloirIndispo || 'Ce produit n\'est actuellement pas disponible.') + '</p>';
    return;
  }

  /* ─── Table de dispo : { variantId: true|false } ─── */
  var avail = {};
  var availKnown = false;

  /* PRIX-COULOIR, 19/10 : LE PRIX MONTRE EST CELUI DU MARCHE.
     `v.p` du metachamp est en centimes d'EURO, fige par
     generate_couloir_matrix.py : affiche tel quel avec le format de la devise
     courante, il donnait « 104 Kc » sur /cs/ pour une variante a 2 468 Kc
     (retour de Lucie, S2.02), et 104 EUR en Italie la ou le panier compte
     124 EUR (liste de prix du marche). La table `prixVivant` porte le
     `v.price` de Liquid (devise et arrondi du marche) : 250 premieres
     variantes dans `data-price-inline`, les suivantes dans la section
     couloir-stock. Sans elle, conversion par `Shopify.currency.rate` hors
     euro (arrondie a l'unite, comme les prix Markets hors euro), sinon `v.p`
     comme avant. Les bornes Klarna restent comparees a `v.p`, en euros. */
  var prixVivant = {};
  function prixDe(v) {
    if (!v) return null;
    if (typeof prixVivant[v.id] === 'number') return prixVivant[v.id];
    var cur = window.Shopify && window.Shopify.currency;
    var taux = cur && cur.active && cur.active !== 'EUR' ? parseFloat(cur.rate) : NaN;
    if (isFinite(taux) && taux > 0) return Math.round(v.p * taux / 100) * 100; /* unites entieres, comme Markets */
    return v.p;
  }

  function isCellAvailable(cell) {
    if (!cell) return false;
    if (!availKnown) return true;      /* aucune info du tout → on n'invente rien */
    return avail[cell.id] === true;    /* inconnu ⇒ indisponible (fail-closed) */
  }

  /* Tous les IDs de variants attendus d'après la matrice */
  function allMatrixIds() {
    var ids = [];
    candidateWidths.forEach(function(w) {
      var cells = byWidth[w];
      Object.keys(cells).forEach(function(k) { ids.push(cells[k].id); });
    });
    return ids;
  }

  /* ─── DOM ─── */
  var widthsContainer = root.querySelector('.couloir-calc__widths');
  var lengthInput     = root.querySelector('.couloir-calc__length-input');
  var btnDec          = root.querySelector('[data-action="decrement"]');
  var btnInc          = root.querySelector('[data-action="increment"]');
  var elPrix          = document.getElementById('couloir-prix');
  var elDimensions    = document.getElementById('couloir-dimensions');
  var elHint          = document.getElementById('couloir-length-hint');
  var btnAtc          = document.getElementById('couloir-atc');
  /* G5.4 : le montant du bouton d'achat. Les deux noeuds sont FACULTATIFS et
     lus avec une garde partout : une page encore en cache sert le bouton sans
     eux, et le calculateur doit continuer de fonctionner mot pour mot. */
  var elAtcMontant    = document.getElementById('couloir-atc-montant');
  var elAtcPrix       = document.getElementById('couloir-atc-prix');
  /* G8, ronde 1 de revue : LE LIBELLE DU BOUTON D'ACHAT, ET SES DEUX MOTS.

     Depuis G8 la ligne de prix est visuellement masquee. Le mot « Indisponible »
     qu'on y ecrivait n'etait donc plus lu par personne : une combinaison
     indisponible ne se signalait plus que par un bouton navy atenue a 50 %,
     sans montant, sans « Acheter maintenant » et sans Klarna, mais portant
     toujours « Ajouter au panier ». Le mot passe donc DANS le bouton, qui est
     ce qu'on regarde.

     LE MOT NORMAL EST LU DANS LE DOCUMENT, PAS ECRIT ICI. Le Liquid l'a deja
     traduit (`products.product.add_to_cart`) : le relire evite une seconde
     source de verite et, surtout, evite un repli francais en dur qui sortirait
     sur /en le temps du premier tour. Meme raison pour `aria-label`, qui porte
     le nom accessible du bouton.

     LE MOT D'INDISPONIBILITE EST CELUI D'AVANT, `S.indisponible`
     (`products.product.unavailable`, `casemira-js-strings.liquid` l.229) :
     aucune clef de locale n'est creee, les quatre langues sont deja servies.

     Les trois nœuds sont FACULTATIFS et lus avec une garde partout : une page
     encore en cache sert le bouton sans eux, et le calculateur doit continuer
     de fonctionner mot pour mot. */
  var elAtcLibelle    = document.getElementById('couloir-atc-libelle');
  var MOT_ACHAT       = elAtcLibelle ? elAtcLibelle.textContent : '';
  var ARIA_ACHAT      = btnAtc ? (btnAtc.getAttribute('aria-label') || '') : '';
  var MOT_INDISPO     = S.indisponible || 'Indisponible';
  function libelleAtc(dispo) {
    if (elAtcLibelle) elAtcLibelle.textContent = dispo ? MOT_ACHAT : MOT_INDISPO;
    /* Le nom accessible suit le libelle visible, et lui seul : il ne bouge pas
       a chaque pression sur + et - (c'est le montant qui change alors, et le
       montant est `aria-hidden` depuis G5.4), il bouge quand l'ETAT change. Un
       bouton qui s'annonce « Ajouter au panier » alors qu'il est desactive et
       qu'il affiche « Indisponible » mentirait a qui ne voit pas l'ecran. */
    if (btnAtc && ARIA_ACHAT) btnAtc.setAttribute('aria-label', dispo ? ARIA_ACHAT : MOT_INDISPO);
  }

  /* Sur-mesure : masque le prix FIXE + le Klarna du HAUT (le calculateur affiche
     le prix calculé + son propre Klarna synchronisé → pas de doublon). */
  (function () {
    var sc = document.querySelector('.section-main-product') || document;
    var tp = sc.querySelector('.product__block--price');
    if (tp) tp.style.display = 'none';
    var tk = document.getElementById('casemira-klarna-line');
    if (tk) { var b = tk.closest('.product__block') || tk; b.style.display = 'none'; }
  })();

  /* ─── STATE ─── */
  var widths = candidateWidths.slice();
  var selectedWidth = widths[0];
  var currentLengths = [];
  var selectedLengthIdx = 0;

  /* Longueurs DISPONIBLES d'une largeur (le stepper ne parcourt que celles-là) */
  function getSortedLengths(w) {
    var cells = byWidth[w] || {};
    return Object.keys(cells)
      .filter(function(k) { return isCellAvailable(cells[k]); })
      .map(Number)
      .sort(function(a, b) { return a - b; });
  }

  function widthHasStock(w) {
    return getSortedLengths(w).length > 0;
  }

  /* ─── Helpers ─── */
  function fmtLen(v) { return v.toFixed(2); }
  /* RETROFIT i18n (R11) · LE FORMAT MONETAIRE SUIT LA LANGUE DE LA PAGE.
     `FoxTheme.casemira.prix` porte le gabarit de la langue courante (« €{{amount}} »
     en anglais, « {{amount_with_comma_separator}} € » en francais) et sa variante
     sans decimales ; `FoxTheme.Currency.formatMoney` sait les appliquer.

     LE FRANCAIS PASSE PAR LA MEME PORTE, et c'est delibere : l'ancien code posait
     une espace de milliers (« 1 234,56 € ») la ou le serveur ecrit un point
     (« 5.329,00 € » sur la collection). Deux verites dans la meme page pour un
     meme montant, c'est le defaut qu'on ferme ici. Le repli reste l'ancien code,
     mot pour mot, si le pont ou `FoxTheme.Currency` manquent : aucun ecran vide. */
  function cmPrixLocalise(cents) {
    if (!window.FoxTheme || !FoxTheme.Currency || !FoxTheme.Currency.formatMoney) return null;
    var P = (FoxTheme.casemira && FoxTheme.casemira.prix) || {};
    var sansZeros = (cents % 100 === 0);
    var fmt = sansZeros ? P.format_sans_zeros : P.format;
    /* R8 : UN BARREAU DE PLUS, entre le pont et le repli code. Quand
       `FoxTheme.casemira.prix` manque (page rendue sans le pont, gabarit vide),
       le theme sait quand meme quel format la langue veut :
       `FoxTheme.settings.moneyFormat` suit la langue depuis R11 (js-variables,
       meme table `cm-prix`, et sans code devise tant que `currency_code_enabled`
       reste faux). Sans lui, une page anglaise retombait droit sur l'euro
       francais du repli. La variante sans decimales se deduit par les deux
       memes remplacements que `cm-prix`, pour que le configurateur garde
       partout son montant sans « ,00 ». En francais les trois barreaux rendent
       la meme chaine : `moneyFormat` y vaut `shop.money_format`. */
    if (!fmt) {
      fmt = (FoxTheme.settings && FoxTheme.settings.moneyFormat) || '';
      if (fmt && sansZeros) {
        fmt = fmt
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
          .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
      }
    }
    if (!fmt) return null;
    try { return FoxTheme.Currency.formatMoney(cents, fmt); } catch (e) { return null; }
  }
  function fmtPrice(cents) {
    var localise = cmPrixLocalise(Math.round(cents));
    if (localise !== null) return localise;
    var eur = Math.round(cents) / 100;
    var s = eur % 1 === 0 ? eur.toFixed(0) : eur.toFixed(2).replace('.', ',');
    if (eur >= 1000) return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
    return s + ' €';
  }
  function updateKlarna(cents, prix) {
    var line = document.getElementById('couloir-klarna');
    if (!line) return;
    if (!cents || cents < 3500 || cents > 150000) { line.style.display = 'none'; return; }
    var inst = document.getElementById('couloir-klarna-installment');
    if (inst) inst.textContent = fmtPrice(Math.ceil((prix || cents) / 3));
    line.style.display = '';
  }
  function findClosestIdx(lengths, target) {
    if (!lengths.length) return 0;
    var best = 0;
    for (var i = 1; i < lengths.length; i++) {
      if (Math.abs(lengths[i] - target) < Math.abs(lengths[best] - target)) best = i;
    }
    return best;
  }

  /* ─── S3, 06/10 : LA LONGUEUR MAXIMALE DISPONIBLE SE DIT ───────────────────
     Depuis la synchro de stock S1, une variante de couloir plus longue que le
     rouleau du fournisseur passe a 0 : `getSortedLengths()` ne la propose plus,
     le panier et Google Shopping suivent. Le client voyait donc le stepper
     s'arreter a 6,00 m sans savoir pourquoi. Ces fonctions le lui disent, sans
     aucune donnee nouvelle : la liste des longueurs disponibles est deja celle
     que le stepper parcourt.

     LE PLAFOND DE REFERENCE EST CELUI DE LA GRILLE DE LA LARGEUR (10,00 m sur
     les 154 fiches relevees), pas un 10 ecrit en dur : une grille qui
     s'arreterait plus tot sans rupture ne doit pas afficher de message.

     LE SEPARATEUR DECIMAL est celui de la langue (`casemira.fiche.couloir_separateur`,
     la cle que le tiroir guide emploie deja pour ses longueurs) : « 6,00 m » en
     francais, « 6.00 m » en anglais. Repli : la virgule, comme `elDimensions`. */
  var SEP_LONGUEUR = S.couloirSeparateur || ',';
  function fmtLongueurLocale(v) { return fmtLen(v).replace('.', SEP_LONGUEUR); }
  function maxDispo() {
    return currentLengths.length ? currentLengths[currentLengths.length - 1] : 0;
  }
  function plafondGrille(w) {
    var cells = byWidth[w] || {};
    var m = 0;
    Object.keys(cells).forEach(function (k) {
      var n = Number(k);
      if (isFinite(n) && n > m) m = n;
    });
    return m;
  }
  /* Vrai seulement quand la largeur a du stock ET s'arrete avant sa grille.
     Largeur sans aucune longueur : comportement existant (largeur ecartee),
     rien de nouveau ici. */
  function dispoReduite() {
    var M = maxDispo();
    return M > 0 && M < plafondGrille(selectedWidth) - 0.005;
  }

  /* LE DEPASSEMENT, ET SEULEMENT LUI (decision de Raphael du 06/10 19h44, apres
     son test). Aucune phrase de stock n'est affichee d'office : tant que la
     longueur choisie tient dans le stock, l'aide est exactement celle d'avant.
     Le message n'apparait que quand le client BUTTE sur la limite : saisie
     au-dela de M, + au bout de la liste disponible, tiroir guide ou lien
     `?longueur=` au-dela de M. L'accroche a la longueur la plus proche reste
     celle d'avant.

     IL RESTE AFFICHE TANT QUE LA SELECTION NE BOUGE PAS (plus de minuterie) :
     on retient la largeur et la longueur au moment ou il est pose, et
     `ecritAide()` ne le montre que si les deux sont encore celles-la. Moins,
     une autre saisie ou une autre largeur le retirent donc d'eux-memes, et
     l'aide habituelle revient. */
  var depasseActif = false;
  var depasseLargeur = null;
  var depasseLongueur = null;
  function signaleDepassement() {
    if (!dispoReduite()) return;
    depasseActif = true;
    depasseLargeur = selectedWidth;
    depasseLongueur = currentLengths[selectedLengthIdx];
  }
  function annuleDepassement() {
    depasseActif = false;
  }
  function demandeDepasse(l) {
    return isFinite(l) && l > maxDispo() + 0.005;
  }
  function depasseVisible() {
    return depasseActif && dispoReduite()
      && depasseLargeur === selectedWidth
      && depasseLongueur === currentLengths[selectedLengthIdx];
  }

  /* L'aide sous le champ longueur : DEUX enfants, poses une seule fois.
     - `.couloir-calc__dispo-max` porte le message de depassement, et lui seul
       porte `aria-live` : une region vivante doit exister AVANT que son texte
       change pour etre annoncee, elle est donc creee vide au premier passage
       et seulement remplie ou videe ensuite (vide, elle ne prend aucune place,
       voir la feuille du snippet) ;
     - `.couloir-calc__aide` porte l'aide habituelle et son lien, comme avant.
     Le lien reste construit ici : seules les phrases et le libelle du lien
     sont des chaines de locale, jamais l'URL ni la balise. */
  var elDepasse = null;
  function ecritAide() {
    if (!elHint) return;
    if (!elDepasse) {
      elHint.innerHTML = '<span class="couloir-calc__dispo-max" aria-live="polite"></span>'
        + '<span class="couloir-calc__aide">'
        + esc(S.couloirHint || 'Besoin d\'une longueur spécifique ou supérieure à 10 m ?')
        + ' <a href="' + CONTACT_URL + '" style="color:#1a1a1a;text-decoration:underline;">'
        + esc(S.couloirContact || 'Contactez-nous') + '</a></span>';
      elDepasse = elHint.querySelector('.couloir-calc__dispo-max');
    }
    var phrase = '';
    if (depasseVisible()) {
      phrase = (S.couloirMaxDispoDepasse || 'Temporairement, cette largeur est disponible jusqu’à [max] m')
        .split('[max]').join(fmtLongueurLocale(maxDispo()))
        /* « 6,00 m » ne se coupe jamais en fin de ligne : espace insecable
           entre le nombre et son unite. */
        .replace(/(\d) (c?m)(?![\wÀ-ɏ])/g, '$1 $2');
    } else {
      depasseActif = false;
    }
    if (elDepasse.textContent !== phrase) elDepasse.textContent = phrase;
  }

  /* ─── Rendu des boutons largeur ─── */
  function renderWidthButtons() {
    widthsContainer.innerHTML = '';
    widths.forEach(function(w) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'couloir-calc__width-btn' + (w === selectedWidth ? ' is-active' : '');
      btn.dataset.largeur = w;
      btn.setAttribute('aria-pressed', w === selectedWidth ? 'true' : 'false');
      btn.innerHTML = '<span class="couloir-calc__width-value">' + w + '</span>' +
                      '<span class="couloir-calc__width-unit">cm</span>';
      widthsContainer.appendChild(btn);
    });
  }

  function soldOutAll() {
    root.innerHTML = '<p style="color:#737373;font-size:14px;">' + esc(S.couloirIndispoForme || 'Ce produit est actuellement indisponible en forme couloir.') + '</p>';
  }

  /* ─── Update UI ─── */
  function update() {
    if (!currentLengths.length) {
      /* La largeur courante n'a plus rien de dispo → on bascule sur une autre */
      var fallback = widths.filter(widthHasStock);
      if (!fallback.length) { soldOutAll(); return; }
      selectedWidth = fallback[0];
      currentLengths = getSortedLengths(selectedWidth);
      selectedLengthIdx = findClosestIdx(currentLengths, 3.00);
      renderWidthButtons();
    }

    if (selectedLengthIdx < 0) selectedLengthIdx = 0;
    if (selectedLengthIdx >= currentLengths.length) selectedLengthIdx = currentLengths.length - 1;

    var lng = currentLengths[selectedLengthIdx];
    var lngKey = lng.toFixed(2);
    var v = byWidth[selectedWidth] ? byWidth[selectedWidth][lngKey] : null;
    var ok = isCellAvailable(v);

    /* R1, 05/09 : L'ETAT DOM, SOURCE DE VERITE DU TIROIR GUIDE.
       AUDIT-COULOIR.md § 8.1 : le tiroir lit la selection courante sur la
       racine du configurateur, jamais par un evenement. Un evenement ne dit
       que ce qui a CHANGE ; a l'ouverture du tiroir, il faut savoir ce QUI EST.
       Les quatre attributs sont donc ecrits ici, dans le meme tour de boucle
       que le prix et AVANT l'emission, pour qu'aucun abonne ne puisse relire un
       etat plus vieux que l'evenement qui vient de le reveiller. */
    root.setAttribute('data-cm-largeur', String(selectedWidth));
    root.setAttribute('data-cm-longueur', lngKey);
    root.setAttribute('data-cm-variant', ok ? String(v.id) : '');
    root.setAttribute('data-cm-dispo', ok ? '1' : '0');
    /* S3, 06/10 : la plus grande longueur DISPONIBLE de la largeur courante,
       en metres, point decimal (meme format que `data-cm-longueur`). Le tiroir
       guide la lit dans `plafond()` pour ne plus proposer au-dela. */
    root.setAttribute('data-max-dispo', fmtLen(maxDispo()));

    /* Le contrat garde son nom, sa cible et ses trois cles (§ 3.3) ; les deux
       cles facultatives du § 8.1 sont AJOUTEES, jamais substituees. */
    document.dispatchEvent(new CustomEvent('couloir:variant-change', {
      detail: {
        width: selectedWidth,
        length: lng,
        variantId: ok ? v.id : null,
        available: ok,
        price: ok ? prixDe(v) : null
      }
    }));

    elDimensions.textContent = selectedWidth + ' cm × ' + fmtLen(lng).replace('.', ',') + ' m';
    lengthInput.value = fmtLen(lng);
    /* S3, 06/10 : l'aide (et, si la largeur s'arrete avant sa grille, la
       longueur maximale disponible) est ecrite par `ecritAide()`. */
    ecritAide();

    /* R1, 05/09 : LE PRIX EST ECRIT ICI, PAS 80 ms PLUS TARD. Il passait par
       `is-updating` (opacite 30 %) puis par un `setTimeout` de 80 ms : trente
       pressions sur + pour aller de 3 m a 6 m produisaient trente
       clignotements du montant. Regle « Le Geste est Instantane » de
       DESIGN.md : « si le libelle s'efface en attendant, c'est une attente,
       pas une prise ». Rien n'est attendu ici, tout est deja en memoire. */
    if (ok) {
      var prix = prixDe(v);
      elPrix.textContent = fmtPrice(prix);
      btnAtc.disabled = false;
      libelleAtc(true);
      updateKlarna(v.p, prix);
      /* G5.4 : LE MEME MONTANT, PAR LE MEME CHEMIN. `fmtPrice` est le seul
         point de mise en forme du fichier (R8) : le bouton ne peut donc pas
         afficher une autre devise ni une autre ponctuation que la ligne de
         prix juste au-dessus, dans aucune langue. */
      if (elAtcPrix) elAtcPrix.textContent = fmtPrice(prix);
      if (elAtcMontant) elAtcMontant.hidden = false;
      marqueLePrix(fmtPrice(prix));
    } else {
      /* Le nœud masque continue d'ANNONCER le mot : c'est lui qui porte
         `aria-live`, et un lecteur d'ecran doit apprendre le changement d'etat
         au moment ou il se produit, sans avoir a revenir sur le bouton. */
      elPrix.textContent = MOT_INDISPO;
      btnAtc.disabled = true;
      libelleAtc(false);
      updateKlarna(null);
      /* Indisponible : le bouton reprend son libelle seul. Un prix sur un
         bouton desactive serait une promesse qu'on ne tient pas. C'est aussi
         la regle de `cartPrice` sur les 900 autres fiches, qui sort si le
         bouton porte `disabled`.
         La classe du fondu part AVEC l'affichage : `animationend` ne se
         declenche pas sur un nœud masque, et une classe restee en place
         rejouerait le fondu au retour de la combinaison. */
      if (elAtcMontant) {
        elAtcMontant.hidden = true;
        elAtcMontant.classList.remove('is-maj');
      }
      marqueLePrix(null);
    }
  }

  /* ─── Events largeur ─── */
  widthsContainer.addEventListener('click', function(e) {
    var btn = e.target.closest('.couloir-calc__width-btn');
    if (!btn || btn.disabled) return;
    widthsContainer.querySelectorAll('.couloir-calc__width-btn').forEach(function(b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    var prevLength = currentLengths[selectedLengthIdx];
    selectedWidth = parseInt(btn.dataset.largeur, 10);
    currentLengths = getSortedLengths(selectedWidth);
    selectedLengthIdx = findClosestIdx(currentLengths, prevLength || 3.00);
    /* S3 : « cette largeur » ne designe plus la meme largeur ; la phrase
       permanente de la nouvelle largeur suffit a expliquer l'accroche. */
    annuleDepassement();
    update();
  });

  /* ─── Sens inverse : le tiroir guide demande une dimension (§ 8.1) ───
     Contrat strict : le detail porte TOUJOURS `width` (centimetres) et
     `length` (metres), meme quand une seule des deux change. On n'accorde
     aucune confiance a ce qu'on recoit : chaque valeur est ACCROCHEE a ce qui
     existe reellement dans la grille, la largeur d'abord (elle commande la
     liste des longueurs), la longueur ensuite. Un tiroir qui demanderait une
     combinaison inexistante ne peut donc pas casser le configurateur. */
  document.addEventListener('couloir:set-dimensions', function (e) {
    var d = (e && e.detail) || {};
    var w = Number(d.width), l = Number(d.length);
    if (!isFinite(w) || !isFinite(l)) return;
    var dispo = widths.filter(widthHasStock);
    if (!dispo.length) return;
    selectedWidth = dispo[findClosestIdx(dispo, w)];
    currentLengths = getSortedLengths(selectedWidth);
    if (!currentLengths.length) return;
    selectedLengthIdx = findClosestIdx(currentLengths, l);
    /* S3 : le tiroir a demande plus que la largeur n'en a en stock. */
    annuleDepassement();
    if (demandeDepasse(l)) signaleDepassement();
    renderWidthButtons();
    update();
  });

  /* ─── Events longueur ─── */

  /* R1, 05/09, retouche 3 : LA VALEUR ARRIVE DANS LE SENS DE LA PRESSION.
     Trois gardes, et chacune vaut une ligne :
      - on n'anime QUE si la valeur a reellement change : au bout de la grille,
        l'absence de mouvement est la reponse juste, un rebond serait un
        mensonge ;
      - on n'anime PAS pendant l'appui long : la valeur y defile a quatorze pas
        par seconde, une animation redemarree toutes les 70 ms n'est plus un
        mouvement, c'est du bruit ;
      - la classe est retiree a la fin de l'animation, par l'evenement de
        l'animation elle-meme et non par un minuteur qui devrait redire la
        duree ecrite dans la feuille. */
  var enAppuiLong = false;
  function marqueLePas(dir) {
    if (enAppuiLong || !lengthInput) return;
    lengthInput.classList.remove('is-pas-plus', 'is-pas-moins');
    void lengthInput.offsetWidth; /* redemarre l'animation sur une pression rapprochee */
    lengthInput.classList.add(dir === 'increment' ? 'is-pas-plus' : 'is-pas-moins');
  }
  if (lengthInput) {
    lengthInput.addEventListener('animationend', function () {
      lengthInput.classList.remove('is-pas-plus', 'is-pas-moins');
    });
  }

  /* G5.3, 06/09 : LE MONTANT SE FOND QUAND IL CHANGE, ET SEULEMENT ALORS.
     Retour de Raph sur le changement de largeur, « une bonne animation ».
     Meme motif que `marqueLePas` juste au-dessus, et QUATRE gardes, chacune
     pour une raison qui se voit a l'ecran :

      - LE MONTANT DOIT AVOIR CHANGE. `update()` est le point de passage
        oblige du calculateur : elle est aussi rappelee par le `blur` du champ
        de longueur, par `couloir:set-dimensions` (meme quand le tiroir du
        guide renvoie la dimension DEJA affichee) et par la resolution
        differee des variantes indisponibles. Sans cette garde, poser le doigt
        ailleurs sur la page faisait refondre un prix qui n'avait pas bouge :
        une animation qui annonce un changement alors qu'il ne s'est rien
        passe est un mensonge, exactement comme le rebond en bout de grille
        que `marqueLePas` refuse deja.
      - PAS AU PREMIER TOUR. Le prix du boot n'arrive pas, il EST : le fondre
        ajouterait un mouvement au chargement de chaque fiche couloir, sur un
        montant que personne n'a demande a changer.
      - PAS PENDANT L'APPUI LONG : a quatorze pas par seconde, un fondu de
        220 ms redemarre avant d'avoir fini et devient un scintillement.
      - LA CLASSE EST RETIREE par l'evenement de fin d'animation, jamais par
        un minuteur qui devrait redire la duree ecrite dans la feuille. Elle
        l'est AUSSI quand le nœud passe `hidden` (combinaison indisponible) :
        `animationend` ne se declenche pas sur un element qui ne s'affiche
        plus, et la classe restee en place aurait rejoue le fondu au retour.

     RIEN N'EST CACHE EN ATTENDANT : le nouveau montant est deja ecrit quand
     l'animation demarre (elle part de l'opacite 0 pour arriver a 1), a la
     difference de l'ancien `is-updating` que R1 avait supprime, qui effacait le
     prix AVANT de connaitre le suivant. La geometrie ne bouge pas : la largeur
     de la boite est reservee par `min-width` (R8). Les deux `void offsetWidth`
     sont des reflux VOLONTAIRES, et le seul moyen de relancer une animation CSS
     sur deux pressions rapprochees : sans eux, la classe reposee dans le meme
     tour de boucle ne redemarre rien. */
  var boitesPrix = [elPrix, elAtcMontant].filter(Boolean);
  var dernierPrix = null;      /* le dernier montant REELLEMENT affiche */
  var premierTour = true;      /* le boot ecrit un prix, il ne le change pas */
  boitesPrix.forEach(function (el) {
    el.addEventListener('animationend', function () { el.classList.remove('is-maj'); });
  });
  function marqueLePrix(texte) {
    /* `boitesPrix` est declare plus bas dans le fichier que `update()` : si un
       jour un appel a `update()` remontait avant cette ligne, la garde repond
       « pas encore » au lieu de lever un TypeError et d'eteindre le prix, le
       bouton et l'evenement `couloir:variant-change`. */
    if (!boitesPrix) return;
    var change = texte !== dernierPrix;
    var premier = premierTour;
    dernierPrix = texte;
    premierTour = false;
    /* `texte` vaut `null` quand la combinaison est indisponible : la ligne de
       prix affiche alors un MOT, pas un montant, et un mot n'a pas a se fondre
       comme un chiffre. Le passage est quand meme enregistre, pour que le
       prochain vrai prix soit vu comme un changement. */
    if (texte === null || premier || !change || enAppuiLong) return;
    boitesPrix.forEach(function (el) {
      el.classList.remove('is-maj');
      void el.offsetWidth;
      el.classList.add('is-maj');
    });
  }

  function step(dir) {
    var avant = selectedLengthIdx;
    if (dir === 'increment' && selectedLengthIdx < currentLengths.length - 1) {
      selectedLengthIdx++;
    } else if (dir === 'decrement' && selectedLengthIdx > 0) {
      selectedLengthIdx--;
    }
    /* S3 : le bouton moins revient sous le maximum : le message temporaire
       n'a plus d'objet, la ligne permanente reprend tout de suite. */
    if (dir === 'decrement') annuleDepassement();
    if (selectedLengthIdx !== avant) marqueLePas(dir);
    /* S3 : + au bout de la liste DISPONIBLE alors que la grille va plus loin. */
    else if (dir === 'increment' && avant === currentLengths.length - 1) signaleDepassement();
    update();
  }

  btnDec.addEventListener('click', function(e) { e.preventDefault(); step('decrement'); });
  btnInc.addEventListener('click', function(e) { e.preventDefault(); step('increment'); });

  var holdTimer = null, holdInt = null, holdBtn = null;
  /* R1 : QUAND LA REPETITION S'ENCLENCHE, LE BOUTON LE DIT. `is-held` garde
     l'icone enfoncee tant que la valeur defile. Sans cette marque, l'appui
     long ne se distinguait pas d'un bouton bloque : la valeur filait et le
     bouton avait l'air relache. La classe est posee sur le bouton, l'icone
     suit par la feuille : le JS ne connait pas la geometrie du mouvement. */
  function startHold(action, btn) {
    holdBtn = btn;
    holdTimer = setTimeout(function() {
      enAppuiLong = true;
      if (holdBtn) holdBtn.classList.add('is-held');
      holdInt = setInterval(function() { step(action); }, 70);
    }, 380);
  }
  function stopHold() {
    clearTimeout(holdTimer); clearInterval(holdInt);
    holdTimer = null; holdInt = null;
    enAppuiLong = false;
    if (holdBtn) { holdBtn.classList.remove('is-held'); holdBtn = null; }
  }
  [btnDec, btnInc].forEach(function(b) {
    var a = b.dataset.action;
    b.addEventListener('pointerdown',  function() { startHold(a, b); });
    b.addEventListener('pointerup',    stopHold);
    b.addEventListener('pointerleave', stopHold);
    b.addEventListener('pointercancel',stopHold);
  });

  lengthInput.addEventListener('focus', function() { this.select(); });
  lengthInput.addEventListener('blur', function() {
    var val = parseFloat(this.value.replace(',', '.'));
    if (isNaN(val)) val = 3.00;
    selectedLengthIdx = findClosestIdx(currentLengths, val);
    /* S3 : saisie au-dela de la longueur disponible (l'accroche ne change pas). */
    if (demandeDepasse(val)) signaleDepassement();
    else annuleDepassement();
    update();
  });
  lengthInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter')     { e.preventDefault(); this.blur(); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); step('increment'); }
    if (e.key === 'ArrowDown') { e.preventDefault(); step('decrement'); }
  });

  /* ─── Filet de sécurité : rupture détectée au moment de l'ATC ─── */
  function dropVariant(cell) {
    if (cell) { avail[cell.id] = false; availKnown = true; }
    widths = widths.filter(widthHasStock);
    if (!widths.length) { soldOutAll(); return; }
    if (widths.indexOf(selectedWidth) === -1) selectedWidth = widths[0];
    currentLengths = getSortedLengths(selectedWidth);
    selectedLengthIdx = findClosestIdx(currentLengths, 3.00);
    renderWidthButtons();
    update();
  }

  /* ─── Ajouter au panier ─── */
  btnAtc.addEventListener('click', function() {
    if (btnAtc.disabled || btnAtc.classList.contains('btn--loading')) return;
    var lng = currentLengths[selectedLengthIdx];
    var lngKey = lng.toFixed(2);
    var v = byWidth[selectedWidth] ? byWidth[selectedWidth][lngKey] : null;
    if (!v) return;

    /* Même animation que l'ATC natif des autres fiches : la classe btn--loading
       fait disparaître le texte (opacity 0) et apparaître le spinner. */
    btnAtc.classList.add('btn--loading');

    /* 14/10/2026 : pictogrammes et date de la fiche en propriétés cachées, pour le mail
       de confirmation (snippets/casemira-proprietes-ligne.liquid). Sans champ, rien. */
    var corps = { id: v.id, quantity: 1 };
    var cachees = window.CasemiraDelivery && window.CasemiraDelivery.lineProperties ? window.CasemiraDelivery.lineProperties(root) : {};
    if (Object.keys(cachees).length) corps.properties = cachees;

    fetch(RACINE + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corps)
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) {
          throw new Error(err.description || err.message || 'stock');
        });
      }
      return r.json();
    })
    .then(function() {
      fetch(RACINE + 'cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count, .js-cart-count, .header__cart-count')
          .forEach(function(el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true, cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:change',  { detail: cart }));
        /* Ouvre le panier (drawer) comme l'ajout standard des autres fiches */
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.show === 'function') { cd.show(); }
      });
      setTimeout(function() {
        btnAtc.classList.remove('btn--loading');
      }, 600);
    })
    .catch(function(err) {
      console.error('[Couloir Calculator]', err);
      btnAtc.classList.remove('btn--loading');

      /* Messages Shopify EN et FR (v10 ne matchait que l'anglais → ne se
         déclenchait jamais sur une boutique en français). */
      var msg = (err.message || '').toLowerCase();
      var stockErr = [
        'stock', 'available', 'sold out', 'not enough', 'inventory', 'cart',
        'disponible', 'rupture', 'épuis', 'epuis',
        'il ne reste', 'ajouté', 'quantit'
      ].some(function(k) { return msg.indexOf(k) > -1; });

      if (stockErr) {
        dropVariant(v);
      } else {
        alert(S.atcErreur || 'Erreur lors de l\'ajout au panier. Veuillez réessayer.');
      }
    });
  });

  /* ─── Init : pré-sélection via ?variant=XXX (Google Shopping) ─── */
  function applyPreselect() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantParam = urlParams.get('variant');
    if (!variantParam) return false;
    var targetId = parseInt(variantParam, 10);

    for (var wi = 0; wi < widths.length; wi++) {
      var w = widths[wi];
      var lengths = getSortedLengths(w);
      for (var li = 0; li < lengths.length; li++) {
        var lKey = lengths[li].toFixed(2);
        if (byWidth[w][lKey] && byWidth[w][lKey].id === targetId) {
          selectedWidth = w;
          currentLengths = lengths;
          selectedLengthIdx = li;
          return true;
        }
      }
    }
    return false;
  }

  /* ─── Init : longueur transmise par la page guide des tailles (G14) ───
     `/pages/guide-des-tailles` calcule une longueur de couloir ou d'escalier
     et emmène le visiteur ici avec `?longueur=<mètres>`. On la lit, et on ne
     lui accorde AUCUNE confiance : la virgule est acceptée (un clavier
     allemand n'écrit pas le point), tout ce qui n'est pas un nombre est
     refusé, et la valeur est bornée à la plage que la grille peut servir
     (0,50 m à 10,00 m, le plafond dit en toutes lettres par le tiroir). Elle
     n'est jamais appliquée telle quelle : `findClosestIdx` l'accroche à une
     longueur qui existe réellement pour la largeur retenue, exactement comme
     le fait `couloir:set-dimensions`. Une valeur absurde ne peut donc pas
     casser le configurateur, au pire elle choisit une longueur voisine.

     `?variant=` reste prioritaire : il désigne une variante précise (Google
     Shopping), là où `?longueur=` n'exprime qu'un souhait. */
  function longueurDemandee() {
    var brut;
    try { brut = new URLSearchParams(window.location.search).get('longueur'); }
    catch (e) { return 0; }
    if (!brut) return 0;
    var n = parseFloat(String(brut).replace(',', '.'));
    if (!isFinite(n) || n <= 0) return 0;
    return Math.min(10, Math.max(0.5, n));
  }

  /* ─── Démarrage effectif, une fois la dispo connue ─── */
  function boot() {
    widths = candidateWidths.filter(widthHasStock);
    if (!widths.length) { soldOutAll(); return; }

    if (widths.indexOf(selectedWidth) === -1) selectedWidth = widths[0];
    currentLengths = getSortedLengths(selectedWidth);

    if (!applyPreselect()) {
      var demandee = longueurDemandee();
      selectedLengthIdx = findClosestIdx(currentLengths, demandee || 3.00);
      /* S3 : la page guide a calcule plus que ce que la largeur a en stock. */
      if (demandee && demandeDepasse(demandee)) signaleDepassement();
    }

    renderWidthButtons();

    /* Masquer le badge "Épuisé" natif Hyper si des largeurs sont dispo */
    document.querySelectorAll('.f-badge--soldout').forEach(function(el) {
      el.style.display = 'none';
    });

    root.classList.remove('is-checking');
    widthsContainer.classList.remove('is-checking');
    update();
  }

  /* ══════════════════════════════════════════════════════════════
     DISPO, 1) ce que Liquid a pu donner (250 premiers variants)
     ══════════════════════════════════════════════════════════════ */
  try {
    var inline = JSON.parse(root.dataset.availInline || '{}');
    Object.keys(inline).forEach(function(id) { avail[id] = inline[id] === 1; });
  } catch (e) {}
  try {
    var prixInline = JSON.parse(root.dataset.priceInline || '{}');
    Object.keys(prixInline).forEach(function(id) { prixVivant[id] = prixInline[id]; });
  } catch (e) {}

  function unresolvedIds() {
    return allMatrixIds().filter(function(id) { return avail[id] === undefined; });
  }

  /* ══════════════════════════════════════════════════════════════
     DISPO, 2) au-dela de 250 : Section Rendering API, page par page
     /products/<handle>?section_id=couloir-stock&page=N
     ══════════════════════════════════════════════════════════════ */
  function fetchStockPage(n) {
    var url = root.dataset.productUrl + '?section_id=' + STOCK_SECTION + '&page=' + n;
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) {
        if (!r.ok) throw new Error('section HTTP ' + r.status);
        return r.text();
      })
      .then(function(htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var node = doc.querySelector('script[data-couloir-stock]');
        if (!node) throw new Error('section couloir-stock introuvable (page ' + n + ')');
        var payload = JSON.parse(node.textContent);
        Object.keys(payload.avail).forEach(function(id) {
          avail[id] = payload.avail[id] === 1;
        });
        if (payload.price) Object.keys(payload.price).forEach(function(id) {
          prixVivant[id] = payload.price[id];
        });
        return payload;
      });
  }

  /* Repli : flags `a` du metafield (snapshot du dernier run de
     generate_couloir_matrix.py). Moins frais que le direct, mais infiniment
     mieux que la v10 qui affichait tout comme disponible. */
  function fallbackToMetafield(why) {
    console.warn('[Couloir Calculator] stock au-delà de 250 non résolu → repli metafield :', why);
    candidateWidths.forEach(function(w) {
      var cells = byWidth[w];
      Object.keys(cells).forEach(function(k) {
        if (avail[cells[k].id] === undefined) avail[cells[k].id] = cells[k].a === 1;
      });
    });
    availKnown = true;
    boot();
  }

  var missing = unresolvedIds();

  if (!missing.length) {
    /* Produit ≤ 250 variants : tout est déjà connu, zéro requête. */
    availKnown = true;
    boot();
  } else {
    var settled = false;
    var timer = setTimeout(function() {
      if (settled) return;
      settled = true;
      fallbackToMetafield('timeout ' + FETCH_TIMEOUT + 'ms');
    }, FETCH_TIMEOUT);

    /* Les variants 1→250 sont déjà couverts : on reprend à la page suivante. */
    var firstPage = Math.floor(INLINE_CAP / PAGE_SIZE) + 1;

    fetchStockPage(firstPage)
      .then(function(p) {
        var rest = [];
        for (var n = firstPage + 1; n <= p.pages; n++) rest.push(fetchStockPage(n));
        return Promise.all(rest);
      })
      .then(function() {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        availKnown = true;
        /* Un ID de la matrice absent de toutes les pages = variant supprimé
           côté Shopify → reste undefined → traité comme indisponible. */
        boot();
      })
      .catch(function(e) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        fallbackToMetafield(e.message);
      });
  }

})();
